module.exports = __webpack_public_path__ + "static/media/imgEmptyList.45589b88.svg";